export default () => ({
  init() {
    // Small delay to ensure DOM is ready
    setTimeout(() => {
      this.initializeHeaderHeight();
    }, 100);
  },

  initializeHeaderHeight() {
    const headerElement = document.getElementById("header-content");
    if (!headerElement) return;

    const cssDefaultHeight =
      parseInt(
        getComputedStyle(document.documentElement).getPropertyValue(
          "--header-content"
        )
      ) ?? 0;

    let previousHeight = 0;
    let debounceTimer = null;

    const updateHeaderHeight = () => {
      try {
        // Calculate combined height of all header children
        const headerChildren = Array.from(headerElement.children);
        const combinedHeight = headerChildren.reduce((total, child) => {
          return total + child.offsetHeight;
        }, 0);

        // Only update if height changed and is different from default
        if (
          combinedHeight !== previousHeight &&
          combinedHeight !== cssDefaultHeight
        ) {
          document.documentElement.style.setProperty(
            "--header-content",
            `${combinedHeight}px`
          );
          previousHeight = combinedHeight;
        }
      } catch {
        console.warn("Failed to update header content height");
      }
    };

    const debouncedHeightUpdate = () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(updateHeaderHeight, 16);
    };

    updateHeaderHeight();

    try {
      const resizeObserver = new ResizeObserver(() => {
        requestAnimationFrame(debouncedHeightUpdate);
      });
      resizeObserver.observe(headerElement);
    } catch {
      window.addEventListener("resize", debouncedHeightUpdate, {
        passive: true,
      });
    }

    this.$cleanup = () => clearTimeout(debounceTimer);
  },
});
